import type { ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';

import { MarketCredit } from '@sorare/core/src/atoms/icons/MarketCredit';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useFacet } from '@sorare/core/src/contexts/graphql-search';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Toggle } from '#src/searchCards/Toggle/index.tsx';
import { ToggleFilter } from '#src/searchCards/ToggleFilter/index.tsx';

const FILTER = TOGGLE_FILTERS.creditEligibleFilter;

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => (
    <ToggleFilter
      icon={<MarketCredit width={24} height={24} />}
      filter={FILTER}
      on={['PrimaryOffer', 'EnglishAuction']}
    />
  ),
  accordionOptions: { startsOpen },
});

const BackendFilter = () => {
  const { refine, value } = useFacet(SEARCH_PARAMS.CREDIT_ELIGIBLE);
  const isRefined = !!value.length;

  const track = useEvents();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.checked;
    track('Use Market Filter', {
      filterName: FILTER.attribute,
      filterValue: newValue.toString(),
    });
    refine(() => (newValue ? ['true'] : []));
  };

  return (
    <Toggle icon={<MarketCredit width={24} height={24} />}>
      <Switch
        checked={isRefined}
        onChange={handleChange}
        label={
          <BodyM bold>
            <FormattedMessage {...FILTER.label} />
          </BodyM>
        }
      />
    </Toggle>
  );
};

export const backendWidget = (): FilterWidget => ({
  key: `${FILTER.attribute}_backend`,
  type: 'toggle',
  attribute: SEARCH_PARAMS.CREDIT_ELIGIBLE,
  Component: BackendFilter,
});
